import { useContext } from 'react';
import AuthContext from './AuthContext';

function useAuthContext() {
  const authContext = useContext(AuthContext);
  if (authContext === undefined) {
    throw new Error('useAuthContext called outside the scope of a provider');
  }
  return authContext;
}

export default useAuthContext;
